"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function first(map) {
    return Array.from(map.values())[0];
}
exports.first = first;
